module.exports = "/_next/static/resources/life2-252d5dc7c54943504620881eebdfad5d.jpg";